import React from 'react';
import { FormikValues } from 'formik';
import blackoutValidationSchema from '@helpers/validationSchemas/blackoutValidationSchema';
import { AddBlackout } from '@pages/Schedule/components/Blackout/BlackoutForm/AddBlackout';
import { EditBlackout } from '@pages/Schedule/components/Blackout/BlackoutForm/EditBlackout';
import { IModalProps } from '@components/Modal/types';
import { IDictionary } from '@constants/languages/types';
import { BlackoutType, blackoutInitialValues } from '@pages/Schedule/components/Blackout/type';
import { ActionType } from '@components/Table/utils/actionsFormatter';
import { formatFormValues } from '@pages/Schedule/utils/blackoutUtils';

export const blackoutFormModal = (
  openModal: (state: IModalProps) => void,
  onSubmit: (formValues: FormikValues, closeModal: () => void) => void,
  dictionary: IDictionary,
  blackoutType: BlackoutType,
  typeAction?: string,
  initialValues?: any,
  blackoutId?: string,
) => {
  const onSubmitForm = async (formValues: FormikValues, closeModal: () => void) => {
    const updatedValues = formatFormValues(formValues);

    onSubmit(updatedValues, closeModal);
  };

  const onSubmitFormForce = async (formValues: FormikValues, closeModal: () => void) => {
    const updatedValues = formatFormValues(formValues);

    onSubmit(
      {
        ...updatedValues,
        confirmed: true,
      },
      closeModal,
    );
  };

  const isEditTypeAction = typeAction === ActionType.edit;

  return openModal({
    children: isEditTypeAction ? (
      <EditBlackout
        blackoutType={blackoutType}
        blackoutId={blackoutId}
        onSubmitFormForce={onSubmitFormForce}
      />
    ) : (
      <AddBlackout onSubmitFormForce={onSubmitFormForce} />
    ),
    initialValues: initialValues || blackoutInitialValues,
    validationSchema: blackoutValidationSchema,
    title: isEditTypeAction
      ? dictionary.blackout.modals.editBlackout.title
      : dictionary.blackout.modals.createBlackout.title,
    closeButton: !isEditTypeAction,
    submitButtonTitle: dictionary.actions.apply,
    onSubmit: onSubmitForm,
  });
};
